/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import marketApi from '@/services/market-api';

const state = {
  promotions: null,
  promotion: null,
  purchaseId: null,
  promocode: null,
  priceRange: null,
  promotionTypes: null,
  partners: null,
  categories: null,
  responseStatus: null,
  errorCode: null,
  categoryOne: null,
  categoryTwo: null,
  categoryThree: null,
  categoryFour: null,
  breadcrumbs: null,
  availiblelimit: null,
};

const mutations = {
  setPromotions(state, value) {
    state.promotions = value;
  },
  setPromotion(state, value) {
    state.promotion = value;
  },
  setPromocode(state, value) {
    state.promocode = value;
  },
  setPriceRange(state, value) {
    state.priceRange = value;
  },
  setPromotionTypes(state, value) {
    state.promotionTypes = value;
  },
  setPartners(state, value) {
    state.partners = value;
  },
  setCategories(state, value) {
    state.categories = value.values ? value.values : [];
  },
  setResponseStatus(state, value) {
    state.responseStatus = value;
  },
  setErrorCode(state, value) {
    state.errorCode = value;
  },
  setPurchaseId(state, value) {
    state.purchaseId = value;
  },
  setCategoryOne(state, value) {
    state.categoryOne = value;
  },
  setCategoryTwo(state, value) {
    state.categoryTwo = value;
  },
  setCategoryThree(state, value) {
    state.categoryThree = value;
  },
  setCategoryFour(state, value) {
    state.categoryFour = value;
  },
  setBreadcrumbs(state, value) {
    state.breadcrumbs = value;
  },
  setAvailiblelimit(state, value) {
    state.availiblelimit = value;
  },
};

const getters = {
  promotions: () => state.promotions,
  promotion: () => state.promotion,
  promocode: () => state.promocode,
  priceRange: () => state.priceRange,
  promotionTypes: () => state.promotionTypes,
  partners: () => state.partners,
  categories: () => state.categories,
  responseStatus: () => state.responseStatus,
  errorCode: () => state.errorCode,
  purchaseId: () => state.purchaseId,
  categoryOne: () => state.categoryOne,
  categoryTwo: () => state.categoryTwo,
  categoryThree: () => state.categoryThree,
  categoryFour: () => state.categoryFour,
  breadcrumbs: () => state.breadcrumbs,
  availiblelimit: () => state.availiblelimit,
};

const actions = {
  buyPromotion({ commit }, { promotionId, purchaseId, promocodesNumber }) {
    return marketApi.buyPromotion({ promotionId, purchaseId, promocodesNumber })
      .then((response) => {
        commit('setResponseStatus', response.status);
        commit('setErrorCode', 0);
        commit('setPurchaseId', response.status === 200 ? response.data : null);
      })
      .catch((error) => {
        commit('setPurchaseId', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
        commit('setErrorCode', error.response && error.response.data ? error.response.data.code || 0 : 0);
      });
  },
  getPromocodes({ commit }, { purchaseId, purchasedPromocodeNumber }) {
    return marketApi.getPromocodes({ purchaseId, purchasedPromocodeNumber })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPromocode', response.data);
        } else {
          commit('setPromocode', null);
        }
      })
      .catch((error) => {
        commit('setPromocode', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
        commit('setErrorCode', error.response && error.response.data ? error.response.data.code || 0 : 0);
      });
  },
  getPromotions({ commit }, {
    offset, count, sort, filters,
  }) {
    return marketApi.getPromotions({
      offset, count, sort, filters,
    })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPromotions', response.data);
        } else {
          commit('setPromotions', null);
        }
      })
      .catch((error) => {
        commit('setPromotions', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getPromotion({ commit }, promotionId) {
    return marketApi.getPromotion({ promotionId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPromotion', response.data);
        } else {
          commit('setPromotion', null);
        }
      })
      .catch((error) => {
        commit('setPromotion', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getPriceRange({ commit }) {
    return marketApi.getPriceRange()
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPriceRange', response.data);
        } else {
          commit('setPriceRange', null);
        }
      })
      .catch((error) => {
        commit('setPriceRange', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getPromotionTypes({ commit }) {
    return marketApi.getPromotionTypes()
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPromotionTypes', response.data);
        } else {
          commit('setPromotionTypes', null);
        }
      })
      .catch((error) => {
        commit('setPromotionTypes', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getPartners({ commit }) {
    return marketApi.getPartners()
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPartners', response.data);
        } else {
          commit('setPartners', null);
        }
      })
      .catch((error) => {
        commit('setPartners', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getCategories({ commit }, { offset, count, sort }) {
    return marketApi.getCategories({ offset, count, sort })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setCategories', response.data);
        } else {
          commit('setCategories', null);
        }
      })
      .catch((error) => {
        commit('setCategories', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getCategoryOne({ commit }, parentId) {
    return marketApi.getCategoriesTree({ parentId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setCategoryOne', response.data);
        } else {
          commit('setCategoryOne', null);
        }
      })
      .catch((error) => {
        commit('setCategoryOne', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getCategoryTwo({ commit }, parentId) {
    return marketApi.getCategoriesTree({ parentId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setCategoryTwo', response.data);
        } else {
          commit('setCategoryTwo', null);
        }
      })
      .catch((error) => {
        commit('setCategoryTwo', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getCategoryThree({ commit }, parentId) {
    return marketApi.getCategoriesTree({ parentId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setCategoryThree', response.data);
        } else {
          commit('setCategoryThree', null);
        }
      })
      .catch((error) => {
        commit('setCategoryThree', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getCategoryFour({ commit }, id) {
    return marketApi.getCategoriesTree({ id })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setCategoryFour', response.data);
        } else {
          commit('setCategoryFou', null);
        }
      })
      .catch((error) => {
        commit('setCategoryFour', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getAllparentsCategory({ commit }, categoryTreeNodeId) {
    return marketApi.getAllparentsCategory({ categoryTreeNodeId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setBreadcrumbs', response.data);
        } else {
          commit('setBreadcrumbs', null);
        }
      })
      .catch((error) => {
        commit('setBreadcrumbs', null);
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getPromotionAvailibleLimit({ commit }, promotionId) {
    return marketApi.getPromotionAvailibleLimit({ promotionId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        commit('setErrorCode', 0);
        if (response.status === 200) {
          commit('setAvailiblelimit', response.data);
        } else {
          commit('setAvailiblelimit', 0);
        }
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        const code = error.response && error.response.data && error.response.data.code ? error.response.data.code : 0;
        commit('setResponseStatus', status || 0);
        commit('setErrorCode', code);
        commit('setAvailiblelimit', 0);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
